module.exports = __webpack_public_path__ + "static/img/006 1.1b5637f8.jpg";